import { ForceGraphConfig } from './forceGraphTypes';

export const DEFAULT_FORCE_GRAPH_CONFIG: ForceGraphConfig = {
    layoutMode: 'force',
    repulsionStrength: 100,
    linkDistance: 50,
    linkStrength: 1,
    collisionPadding: 4,
    gravityStrength: 0.1,

    minNodeRadius: 4,
    maxNodeRadius: 20,
    nodeOpacity: 0.9,
    nodeColorMode: 'group',
    nodeSingleColor: '#4f46e5',
    showNodeLabels: true,
    labelMode: 'all',
    labelTopN: 10,

    linkMinWidth: 1,
    linkMaxWidth: 5,
    linkOpacity: 0.6,
    linkColorMode: 'single',
    linkSingleColor: '#94a3b8',
    showArrows: true,
    curvedLinks: false,

    enableZoomPan: true,
    enableDragging: true,
    pinOnDrag: false,

    legendMode: 'nodes',
    legendPosition: 'bottom-right'
};
